import React, { useEffect, useState } from "react";
import "./index.css";

import TechnicalErrorIconSvg from "../../../helpers/technicalError";
import check from "../../../images/check.png";
import { useDispatch, useSelector } from "react-redux";
import { correctOptionsForInvalidDoc } from "../../../helpers";
import { LIVEFEEDBACK_INVALID_DOC } from "../../../actions/actionTypes";
import { useFileRemoval } from "../../../helpers/useFileRemoval";
import Footer from "../Footer";
export default function LiveFeedbackInvalidPopup({ allFiles, setAllFiles, allProcessedFiles, setAllProcessedFiles }) {

    const subcategorySelected = useSelector(
        (state) => state.livefeedback?.subcategorySelected
    );

    const documentNotSelected = useSelector(
        (state) => state.livefeedback?.documentNotSelected
    );

    const liveFeedbackData = useSelector(
        (state) => state.livefeedback?.livefeedbackData
    );

    const lastLinkClickedData = useSelector(
        (state) => state.lastLinkClicked?.dataSuccess
    );

    const dispatch = useDispatch();

    const [options, setOptions] = useState([]);

    useEffect(() => {
        correctOptionsForInvalidDoc(lastLinkClickedData?.category, liveFeedbackData, subcategorySelected, documentNotSelected, setOptions);
    }, [])

    const { handleDelete, redirectToUpload } = useFileRemoval({
        allFiles,
        setAllFiles,
        allProcessedFiles,
        setAllProcessedFiles,
    });

    // Function to handle try again button click.
    const handleTryAgain = () => {
        dispatch({ type: LIVEFEEDBACK_INVALID_DOC, payload: false });
        handleDelete();
        redirectToUpload();
    }


    const pleaseTryStyleOverride = { textDecoration: liveFeedbackData?.isCategoryInvalid ? "none" : "underline", margin: liveFeedbackData?.isCategoryInvalid ? "auto" : "0px" }


    return (
        <div className="live-feedback-invalid-popup-wrapper popup">

            <div className="live-feedback-invalid-popup-content-wrapper">

            <div className="live-feedback-invalid-popup-content">
                <div className="live-feedback-invalid-popup-icon"><TechnicalErrorIconSvg /></div>
                <div className="upload-title-text">This document may be invalid</div>
            </div>

            <div className="live-feedback-invalid-popup-content">
                <div className="please-try upload-content-text" style={pleaseTryStyleOverride}>
                    {liveFeedbackData?.isCategoryInvalid ? "Please try with correct document category i.e. " + options[0] : "Please try:"}
                </div>

                <div className="please-try-list" style={{ display: liveFeedbackData?.isCategoryInvalid ? "none" : "block" }}>
                    {options.map((option, index) => (
                        <div className="please-try-list-item upload-content-text" key={index}>
                            <img src={check} height={13} alt="check icon" />
                            {option}
                        </div>
                    ))}
                </div>

            </div>

            <div className="live-feedback-invalid-popup-footer">

                <div className="live-feedback-invalid-popup-footer-buttons">
                    <button className="upload-button" onClick={handleTryAgain}>Try again</button>
                </div>
            </div>
            </div>

            <Footer />
        </div>
    );
}
